var thePaginator = new function () {
    $(document).on('RefreshPaginator', function(event){
      thePaginator.paginator(true);
    });

	this.paginator = function(reset)
	{
		if (reset)
		{
			$('.Paginator').removeClass('paginator-loaded').find('.page-link').remove();
		}

		$('.Paginator:not(.paginator-loaded)').each(function()
		{
			var $Paginator = $(this);
			var	$PaginatorInput = $Paginator.find('input');	// Free text page input
			var	$PaginatorPages = $Paginator.find('>span');

			$Paginator.addClass('paginator-loaded');

			var TotalRecords = parseInt($PaginatorInput.attr('TotalRecords'));
			var RecordsPerPage = parseInt($Paginator.parent().find('.RecordCounter :input').val());
			var MaxPages = Math.ceil(TotalRecords / RecordsPerPage);

			var SelectedPage = parseInt($PaginatorInput.val());
			if (SelectedPage <= 0)
				SelectedPage = 1;
			else if (SelectedPage > MaxPages)
				SelectedPage = MaxPages;

			// Try to get the selectpage in the middle of the page list
			var	FirstPage = SelectedPage - 3;
			if (FirstPage < 1)
				FirstPage = 1;
			var LastPage = FirstPage + 7;
			if (LastPage > MaxPages)
			{
				LastPage = MaxPages;
				FirstPage = LastPage - 7;
				if (FirstPage < 1)
					FirstPage = 1;
			}

			// Create the page links
			for (var i = LastPage; i >= FirstPage; i--)
			{
				$Paginator.find('a:first').after('<a href="" class="page-link">' + i.toString() + '</a>');
			}

			$Paginator.find('.page-link').on('click', function(event)
			{
				event.preventDefault();
				var NewPageNum = $(this).text();

				// it looks like, when cloned (for the sticky footer), this event listener is also cloned
				// so first time $PaginatorInput here is the input
				// from the original paginator (closures capture outer scope)
				// so we cannot use the following expression
				// $PaginatorInput.val(NewPageNum);
				let input = $(this).closest('.Paginator').find('input');

				// set all page number inputs to the same value (all in all, they should be sync-ed)
				// so pageLinkActivate will work properly immidiately
				$('.Paginator').find('input').val(NewPageNum);

				GoToPage(input[0]);
			});

			$.extend($Paginator,
			{
				pageLinkActivate: function()
				{
					let paginator = $(this).closest('.Paginator');
					let input = paginator.find('input');
					let paginatorPages = paginator.find('>span');
					var CurrentPage = input.val();
					var Offset = CurrentPage - FirstPage;
					paginator.find('a.page-link').removeClass('active');
					paginator.find('a.page-link').eq(Offset).addClass('active');

					var	_start = ((CurrentPage - 1) * RecordsPerPage) + 1;
					var	_end = _start + RecordsPerPage - 1;
					if (_end > TotalRecords)
					  _end = TotalRecords;
					paginatorPages.text((paginatorPages.text().replace(/\d+\-\d+/, _start + '-' + _end)).trim());
				}
			});

			$Paginator.pageLinkActivate();
		});

		this.recordCounter = function() {
			$('.RecordCounter:not(.recordCounter-loaded)').each(function() {
				var $RecordCounter = $(this),
					$RecordCounterInput = $RecordCounter.find('input');
				$RecordCounter.addClass('recordCounter-loaded');
				$RecordCounter.append('<ul><li data-value="10">10</li><li data-value="20">20</li><li data-value="50">50</li><li data-value="100">100</li><li data-value="200">200</li></ul><img class="icon svgIcon" src="/Images/icons.svg#chevron-down">');
				var $RecordCounterMenu = $RecordCounter.find('ul');
				$RecordCounterInput.on('focus blur', function(event) {
					if (event.type == 'focus'){
						$RecordCounterMenu.show();
					} else {
						$RecordCounterMenu.hide();
					}
				});
				$RecordCounter.find('img').on('click', function(event) {
					$RecordCounterInput.focus();
				});
				$RecordCounterMenu.find('li').on('mousedown', function() {
					$RecordCounterInput.val($(this).data('value')).trigger('change');
				});
			});
		}
	}
};


function SetRecordsPerPage(Element)
{
	var ListName = GetListName(Element);
	if (ListName)
	{
		var List = GlobalList.GetList(ListName);
		if (List)
		{
			var RecordsPerPage = ForceToNumber(Element.value, 1, 200, 1);
			Element.value = RecordsPerPage;
			List.RecordsPerPage = RecordsPerPage;
			List.Refresh(true);
		}
	}
}

